<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/W1IpUl/tc-custom/9781250178930.jpg?1738254612403" alt="This image is the cover for the book Summerland"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Summerland
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"It reads like John Le Carré if Le Carré ate a ton of acid before writing <i>Tinker Tailor Soldier Spy</i>." </b>—<b>NPR on <i>Summerland</i></b><br/><br/><b>From Hannu Rajaniemi, one of the most exciting science fiction writers in the last decade, comes an awe-inspiring account of the afterlife and what happens when it spills over into the world of the living</b><br/><br/> Loss is a thing of the past. Murder is obsolete. Death is just the beginning.<br/><br/> In 1938, death is no longer feared but exploited. Since the discovery of the afterlife, the British Empire has extended its reach into Summerland, a metropolis for the recently deceased.<br/><br/> Yet Britain isn’t the only contender for power in this life and the next. The Soviets have spies in Summerland, and the technology to build their own god.<br/><br/> When SIS agent Rachel White gets a lead on one of the Soviet moles, blowing the whistle puts her hard-earned career at risk. The spy has friends in high places, and she will have to go rogue to bring him in.<br/><br/> But how do you catch a man who’s already dead?<br/><br/> Other Tor books by Hannu Rajaniemi:<br/><br/><b>Jean le Flambeur series</b><br/> 1. <i>The Quantum Thief</i><br/> 2. <i>The Fractal Prince</i><br/> 3. <i>The Casual Angel</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hannu Rajaniemi
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9be1881a